import '@/i18n/config.ts';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App.tsx';
import { Toaster } from './components/toast-message/sonner.tsx';
import { SubscribePrice } from './provider/SubscribePrice.tsx';
import { AuthProvider } from './provider/auth-provider.tsx';
import './index.css';
import { ErudaProvider } from './components/edura/index.tsx';
import MiniKitProvider from './minikit-provider.tsx';
import SubscribeTrade from './components/SubscribeTrade.tsx';
import { DailyReward } from './components/rewards/index.tsx';
import { RegionBlocked } from './RegionBlocked.tsx';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <RegionBlocked>
            <MiniKitProvider>
                <ErudaProvider>
                    <BrowserRouter>
                        <AuthProvider>
                            <App />
                            <SubscribePrice />
                            <SubscribeTrade />
                            <Toaster position="top-center" />
                            <DailyReward />
                        </AuthProvider>
                    </BrowserRouter>
                </ErudaProvider>
            </MiniKitProvider>
        </RegionBlocked>
    </StrictMode>
);
